module.exports = __webpack_public_path__ + "img/oise-logo.b09c6b30.png";